import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom";

import { createRoot } from "react-dom/client";

import { store } from "./redux/store";
import { Provider } from "react-redux";
import Splide from "@splidejs/splide";
import tippy from "tippy.js";

import LoadingIndicator from "./components/LoadingIndicator";
import BookmarkIcon from "./components/pdSearch/upcomingEvents/BookmarkIcon";
import "./pdDetailsReactRegister";

const SiteSearchInput = lazy(
    () => import("./components/siteSearch/SiteSearchInput")
);

const SiteSearchListing = lazy(
    () => import("./components/siteSearch/SiteSearchListing")
);
const SiteSearchFilters = lazy(
    () => import("./components/siteSearch/SiteSearchFilters")
);

const MobileNavigation = lazy(
    () => import("./components/mobileNavigation/MobileNavigation")
);

const SearchPdPage2025 = lazy(
    () => import("./components/pdSearch/SearchPdPage2025")
);

const SearchPd2025 = lazy(
    () => import("./components/pdSearch/SearchPd2025")
);

const FormComponent = lazy(() => import("./formBuilder/formComponent"));

const NewsListing = lazy(
    () => import("./components/news/NewsListing")
);

const NewsListingFilters = lazy(
    () => import("./components/news/NewsListingFilters")
);

const SearchPdCalendar = lazy(
    () => import("./components/pdCalendar/SearchPdCalendar")
);

const globalAny: any = global;
globalAny.React = React;
globalAny.ReactDOM = ReactDOM;
globalAny.createRoot = createRoot;
globalAny.Splide = Splide;
globalAny.tippy = tippy;

globalAny.SiteSearchInput = (props: any) => (
    <Provider store={store}>
        <Suspense fallback={<LoadingIndicator />}>
            <SiteSearchInput {...props} />
        </Suspense>
    </Provider>
);

globalAny.SiteSearchFilters = (props: any) => (
    <Provider store={store}>
        <Suspense fallback={<LoadingIndicator />}>
            <SiteSearchFilters {...props} />
        </Suspense>
    </Provider>
);

globalAny.SiteSearchListing = (props: any) => (
    <Provider store={store}>
        <Suspense fallback={<LoadingIndicator />}>
            <SiteSearchListing {...props} />
        </Suspense>
    </Provider>
);

globalAny.SearchPdPage2025 = (props: any) => (
    <Provider store={store}>
        <Suspense fallback={<LoadingIndicator />}>
            <SearchPdPage2025 {...props} />
        </Suspense>
    </Provider>
);

globalAny.SearchPd2025 = (props: any) => (
    <Provider store={store}>
        <Suspense fallback={<LoadingIndicator />}>
            <SearchPd2025 {...props} />
        </Suspense>
    </Provider>
);

globalAny.MobileNavigation = (props: any) => (
    <Provider store={store}>
        <Suspense fallback={<LoadingIndicator />}>
            <MobileNavigation {...props} />
        </Suspense>
    </Provider>
);

globalAny.FormComponent = (props: any) => (
    <Provider store={store}>
        <Suspense fallback={<LoadingIndicator />}>
            <FormComponent {...props} />
        </Suspense>
    </Provider>
);

globalAny.NewsListing = (props: any) => (
    <Provider store={store}>
        <Suspense fallback={<LoadingIndicator />}>
            <NewsListing {...props} />
        </Suspense>
    </Provider>
);

globalAny.NewsListingFilters = (props: any) => (
    <Provider store={store}>
        <Suspense fallback={<LoadingIndicator />}>
            <NewsListingFilters {...props} />
        </Suspense>
    </Provider>
);

globalAny.SearchPdCalendar = (props: any) => (
    <Provider store={store}>
        <Suspense fallback={<LoadingIndicator />}>
            <SearchPdCalendar {...props} />
        </Suspense>
    </Provider>
);

globalAny.UpcomingEventBookMark = (props: any) => (
    <Provider store={store}>
        <Suspense fallback={<LoadingIndicator />}>
            <BookmarkIcon {...props} />
        </Suspense>
    </Provider>
);


export default globalAny;